module.exports = __webpack_public_path__ + "img/x2_3f3c6f8a7.png";